import i18next from 'i18next';

i18next.addResources('es', 'fundingSelector', {
  all: 'Todos',
  funding: 'Financiamiento',
  public: 'Público',
  private: 'Privado',
  mixed: 'Mixto'
});
